module.exports = __webpack_public_path__ + "img/Wohnflache.3b6435b6.svg";